export enum LanguageSwitcherTheme {
  DARK = 'dark',
  LIGHT = 'light',
}
